import { render } from "./VBtnAdapted.vue?vue&type=template&id=aa38195a&ts=true"
import script from "./VBtnAdapted.vue?vue&type=script&lang=ts"
export * from "./VBtnAdapted.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__